import { createRoute } from '@/utils/routing'

export const CZCB_SWIFT_LIST_ROUTE = 'czcb-swifts'
export const CZCB_SWIFTS_UPLOAD_ROUTE = 'czcb-swifts-upload'

export function createCzcbSwiftListRoute (options = {}) {
  return createRoute(CZCB_SWIFT_LIST_ROUTE, options)
}

export function createCzcbSwiftsUploadRoute (options = {}) {
  return createRoute(CZCB_SWIFTS_UPLOAD_ROUTE, options)
}
